import { defineMessages } from 'react-intl';

export default defineMessages({
  faq: 'FAQ',
  faucet: 'Faucet',
  killSwitchProtocol: 'KillSwitch Protocol',
  developers: 'Developers',
  security: 'Security',
});
